import React from 'react';
import Button from '../components/ui/Button';
import Card from '../components/ui/Card';
import { MessageSquareIcon, PhoneCallIcon, LayoutDashboardIcon, CalendarIcon, FileTextIcon, ActivityIcon, UsersIcon, SmartphoneIcon, ShieldCheckIcon } from 'lucide-react';
export default function Features() {
  const features = [{
    icon: MessageSquareIcon,
    title: 'Daily SMS Reminders',
    description: 'Receive automated text message reminders at scheduled times for medications and appointments. Clear, simple messages that are easy to read and understand.'
  }, {
    icon: PhoneCallIcon,
    title: 'Automated Phone Call Alerts',
    description: 'Get voice call reminders for important medications or appointments. Perfect for those who prefer hearing a reminder rather than reading a text.'
  }, {
    icon: LayoutDashboardIcon,
    title: 'Family Dashboard',
    description: 'Allow family members to view reminder confirmations and stay informed about medication adherence. See at a glance when reminders have been acknowledged.'
  }, {
    icon: CalendarIcon,
    title: 'Appointment Tracking',
    description: 'Keep all upcoming GP visits, hospital appointments, and check-ups organised in one place. Never miss an important medical appointment again.'
  }, {
    icon: FileTextIcon,
    title: 'Repeat Prescription Notes',
    description: 'Store notes about repeat prescriptions, dosage changes, and medication schedules. Keep track of what needs to be reordered and when.'
  }, {
    icon: ActivityIcon,
    title: 'Blood Test & GP Visit Tracking',
    description: 'Record blood test results, GP visit notes, and follow-up actions. Maintain a complete history of medical visits and test outcomes.'
  }, {
    icon: UsersIcon,
    title: 'Carer Note-Sharing',
    description: 'Share important notes between family members and carers. Ensure everyone involved in care has access to the latest information.'
  }, {
    icon: SmartphoneIcon,
    title: 'Accessible for Elderly Users',
    description: 'Designed with simplicity in mind. Large text, clear buttons, and straightforward navigation make it easy for older adults to use independently.'
  }, {
    icon: ShieldCheckIcon,
    title: 'Secure Cloud Storage (GDPR Compliant)',
    description: 'Your data is stored securely in the cloud with industry-leading encryption. Fully compliant with UK GDPR regulations for peace of mind.'
  }];
  return <div className="w-full" data-id="element-295">
      {/* Hero Section */}
      <section className="bg-gradient-to-b from-white to-light-grey py-16" data-id="element-296">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-297">
          <h1 className="text-4xl md:text-5xl font-bold text-navy font-heading mb-6" data-id="element-298">
            Features
          </h1>
          <p className="text-xl text-dark leading-relaxed" data-id="element-299">
            Artisanfix helps older adults and families stay organised with daily
            reminders for medication and appointments, delivered through SMS or
            phone call.
          </p>
        </div>
      </section>
      {/* Features Grid */}
      <section className="py-16 bg-white" data-id="element-300">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-301">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-302">
            {features.map((feature, index) => <Card key={index} className="hover:shadow-lg transition-shadow h-full" data-id="element-303">
                <div className="flex flex-col h-full" data-id="element-304">
                  <div className="flex-shrink-0 mb-4" data-id="element-305">
                    <div className="rounded-full bg-light-grey p-4 w-16 h-16 flex items-center justify-center" data-id="element-306">
                      <feature.icon className="h-8 w-8 text-navy" data-id="element-307" />
                    </div>
                  </div>
                  <h3 className="text-xl font-bold text-navy mb-3" data-id="element-308">
                    {feature.title}
                  </h3>
                  <p className="text-dark" data-id="element-309">{feature.description}</p>
                </div>
              </Card>)}
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="bg-light-grey py-16" data-id="element-310">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-311">
          <h2 className="text-3xl font-bold text-navy font-heading mb-4" data-id="element-312">
            Ready to Get Started?
          </h2>
          <p className="text-lg text-dark max-w-3xl mx-auto mb-8" data-id="element-313">
            Choose a plan that works for your family and start enjoying peace of
            mind today.
          </p>
          <div className="flex flex-wrap justify-center gap-4" data-id="element-314">
            <Button size="lg" href="/pricing" data-id="element-315">
              View Pricing Plans
            </Button>
            <Button variant="outline" size="lg" href="/contact" data-id="element-316">
              Contact Us
            </Button>
          </div>
        </div>
      </section>
    </div>;
}